// extracted by mini-css-extract-plugin
export default {"songCard":"Dashboard_songCard__5mCeX"};